import { SetStateAction } from 'react';

import { SelectedG500LiteMasterInfoType } from '../../../common/component/hooks/useStateSelectedG500LiteMasterInfo';
import { SelectedOffsegMasterInfoType } from '../../../common/component/hooks/useStateSelectedOffsegMasterInfo';
import { DateType, formatDate } from '../../../common/utils/dateHandler';
import { MasterInfo } from '../../../common/type/MasterInfoType';
import { DialogType } from '../../../common/type/DialogType';

import { searchType } from '../../const/carUseResultPageConst';
import { getCarUseResultHandler } from '../../feature/handler/getCarUseResultHandler';
import { CarUseResultInfoType } from '../../feature/type/CarUseResultInfoType';

type InputType = {
	setIsAsyncProcess: (value: SetStateAction<boolean>) => void;
	isCarSelectedAsKey: boolean;
	selectedOffsegMasterInfo: SelectedOffsegMasterInfoType;
	selectedG500LiteMasterInfo: SelectedG500LiteMasterInfoType;
	searchDate: DateType | null;
	masterInfo: MasterInfo;
	setDialog: (value: SetStateAction<DialogType>) => void;
	setCarUseResultInfoList: (value: React.SetStateAction<CarUseResultInfoType[]>) => void;
};

/**
 * 車両利用実績一覧取得用カスタムフック
 */
export const useGetCarUseResult = (input: InputType) => {
	const {
		setIsAsyncProcess,
		isCarSelectedAsKey,
		selectedOffsegMasterInfo,
		selectedG500LiteMasterInfo,
		searchDate,
		masterInfo,
		setDialog,
		setCarUseResultInfoList,
	} = input;

	// 検索ボタンを押下した際の処理
	const onClickSearch = async () => {
		// ローディング表示開始
		setIsAsyncProcess(true);

		const requestParams = {
			searchType: isCarSelectedAsKey ? searchType.car : searchType.driver,
			offsegOrganizationId: selectedOffsegMasterInfo.selectedOffsegOrganizationInfo.id,
			offsegCarId: selectedOffsegMasterInfo.selectedOffsegCarInfo.id,
			offsegDriverId: selectedOffsegMasterInfo.selectedOffsegDriverInfo.id,
			g500LiteOrganizationId: selectedG500LiteMasterInfo.selectedG500LiteOrganizationInfo.id,
			g500LiteCarId: selectedG500LiteMasterInfo.selectedG500LiteCarInfo.id,
			searchDate: formatDate(searchDate),
		};

		// 車両利用実績一覧を取得
		const [dialog, carUseResultList] = await getCarUseResultHandler(requestParams, masterInfo);

		// ローディング表示終了
		setIsAsyncProcess(false);

		if (!carUseResultList) {
			setDialog(dialog);
			return;
		}

		setCarUseResultInfoList(carUseResultList);
	};

	return { onClickSearch };
};
